"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContractStructureTree = ContractStructureTree;
const react_1 = __importStar(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const FormContext_1 = require("../../../View/Modals/FormContext");
const BussinesObjectSelectors_1 = require("../../../View/Modals/CommonFormComponents/BussinesObjectSelectors");
const contractTemplatesTreeService_1 = require("./contractTemplatesTreeService");
/**
 * Drzewo struktury tworzonej razem z umową: kamienie milowe -> sprawy, plus
 * osobna sekcja folderów na Dysku niebędących sprawami.
 *
 * Pozycją drzewa jest TYP, nie szablon — dzięki temu widać cały słownik
 * dostępny dla typu umowy, a nie tylko pozycje mające szablon. Zaznaczone
 * startowo jest dokładnie to, co powstaje dziś automatycznie; regułę liczy
 * serwer (isCheckedByDefault) i nie wolno jej tu odtwarzać.
 *
 * Renderowany tylko przy dodawaniu umowy.
 */
/** Dopiski, których serwer nie musi znać — to czysto UI-owa podpowiedź. */
const FOLDER_HINTS = {
    MEETING_PROTOCOLS: "Jeśli nie utworzysz teraz, folder powstanie sam przy pierwszej notatce ze spotkania.",
};
/** Kamienie milowe wyróżnione rozmiarem — sprawy zostają w rozmiarze bazowym. */
const MILESTONE_LABEL_STYLE = { fontSize: "1.0625rem" };
/**
 * Wiersz z checkboxem — wspólny dla kamieni, spraw i folderów.
 * Rodzaju pozycji nie oznaczamy ikoną: kamienie od spraw odróżnia wcięcie
 * i rozmiar tekstu, a foldery są w osobnej sekcji. Ikona zostaje tylko tam,
 * gdzie niesie treść, czyli przy folderach na Dysku.
 */
function CheckRow({ id, checked, muted, icon, labelClassName = "", labelStyle, onChange, children, }) {
    return (react_1.default.createElement("div", { className: "d-flex align-items-start" },
        icon && (react_1.default.createElement("span", { className: "text-muted me-2", style: { width: "1.1rem", display: "inline-block", textAlign: "center" } },
            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: icon, title: "folder na Dysku", size: "sm" }))),
        react_1.default.createElement(react_bootstrap_1.Form.Check, { type: "checkbox", id: id },
            react_1.default.createElement(react_bootstrap_1.Form.Check.Input, { type: "checkbox", checked: checked, onChange: (e) => onChange(e.target.checked) }),
            react_1.default.createElement(react_bootstrap_1.Form.Check.Label, { className: `${muted ? "text-muted" : ""} ${labelClassName}`.trim(), style: labelStyle }, children))));
}
/** Etykieta typu: numer folderu, nazwa typu, ikona unikalności, nazwa szablonu pod spodem. */
function TypeLabel({ folderNumber, typeName, isUnique, templateName, }) {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        folderNumber,
        " ",
        typeName,
        react_1.default.createElement(BussinesObjectSelectors_1.UniquenessIcon, { isUnique: isUnique }),
        templateName && react_1.default.createElement("div", { className: "text-muted small" }, templateName)));
}
function ContractStructureTree() {
    const { setValue, watch, formState: { errors }, } = (0, FormContext_1.useFormContext)();
    const contractTypeId = watch("_type")?.id;
    const selection = watch("_milestonesSelection") ?? [];
    const selectedFolders = watch("_contractFoldersSelection") ?? [];
    const [tree, setTree] = (0, react_1.useState)(null);
    const [errorMessage, setErrorMessage] = (0, react_1.useState)(null);
    const [expanded, setExpanded] = (0, react_1.useState)(new Set());
    const [reloadToken, setReloadToken] = (0, react_1.useState)(0);
    // Pamięć spraw odznaczonych razem z kamieniem: ponowne zaznaczenie kamienia
    // przywraca to, co użytkownik miał, a nie zestaw domyślny. Ref, nie state —
    // nie ma powodować re-renderu. GeneralModalContent montuje się od nowa przy
    // każdym otwarciu modala, więc pamięć resetuje się per sesja formularza.
    const rememberedCasesRef = (0, react_1.useRef)(new Map());
    // Drzewo per typ umowy — przełączanie typu tam i z powrotem nie odpytuje serwera.
    const cacheRef = (0, react_1.useRef)(new Map());
    function writeSelection(next) {
        setValue("_milestonesSelection", next, { shouldValidate: true });
    }
    (0, react_1.useEffect)(() => {
        if (!contractTypeId) {
            setTree(null);
            setErrorMessage(null);
            setExpanded(new Set());
            writeSelection([]);
            setValue("_contractFoldersSelection", []);
            return;
        }
        const applyTree = (loaded) => {
            setTree(loaded);
            setErrorMessage(null);
            setExpanded(new Set());
            rememberedCasesRef.current = new Map();
            writeSelection(loaded.milestoneTypes
                .filter((node) => node.isCheckedByDefault)
                .map((node) => ({
                milestoneTypeId: node.milestoneTypeId,
                caseTypeIds: node.caseTypes
                    .filter((caseType) => caseType.isCheckedByDefault)
                    .map((caseType) => caseType.caseTypeId),
            })));
            setValue("_contractFoldersSelection", loaded.optionalFolders.filter((folder) => folder.isDefault).map((folder) => folder.key));
            setValue("_contractStructureTreeUnavailable", false, { shouldValidate: true });
        };
        const cached = cacheRef.current.get(contractTypeId);
        if (cached) {
            applyTree(cached);
            return;
        }
        let cancelled = false;
        setTree(null);
        setErrorMessage(null);
        (0, contractTemplatesTreeService_1.fetchContractTemplatesTree)(contractTypeId)
            .then((loaded) => {
            if (cancelled)
                return;
            cacheRef.current.set(contractTypeId, loaded);
            applyTree(loaded);
        })
            .catch((err) => {
            if (cancelled)
                return;
            setErrorMessage(err instanceof Error ? err.message : "Nieznany błąd");
        });
        return () => {
            cancelled = true;
        };
    }, [contractTypeId, reloadToken, setValue]);
    function toggleExpanded(milestoneTypeId) {
        setExpanded((prev) => {
            const next = new Set(prev);
            if (next.has(milestoneTypeId))
                next.delete(milestoneTypeId);
            else
                next.add(milestoneTypeId);
            return next;
        });
    }
    function toggleMilestone(node, checked) {
        if (checked) {
            const remembered = rememberedCasesRef.current.get(node.milestoneTypeId);
            const caseTypeIds = remembered ??
                node.caseTypes.filter((caseType) => caseType.isCheckedByDefault).map((caseType) => caseType.caseTypeId);
            writeSelection([...selection, { milestoneTypeId: node.milestoneTypeId, caseTypeIds }]);
            // Zaznaczenie rozwija, żeby od razu było widać, co powstanie w środku
            setExpanded((prev) => new Set(prev).add(node.milestoneTypeId));
            return;
        }
        const current = selection.find((item) => item.milestoneTypeId === node.milestoneTypeId);
        if (current)
            rememberedCasesRef.current.set(node.milestoneTypeId, current.caseTypeIds);
        writeSelection(selection.filter((item) => item.milestoneTypeId !== node.milestoneTypeId));
    }
    function toggleCase(node, caseTypeId, checked) {
        const current = selection.find((item) => item.milestoneTypeId === node.milestoneTypeId);
        if (!current) {
            // Sprawa w niezaznaczonym kamieniu zaznacza też kamień, ale bierze
            // WYŁĄCZNIE wskazaną sprawę — użytkownik wskazał konkretną pozycję.
            if (!checked)
                return;
            writeSelection([...selection, { milestoneTypeId: node.milestoneTypeId, caseTypeIds: [caseTypeId] }]);
            return;
        }
        const caseTypeIds = checked
            ? [...current.caseTypeIds, caseTypeId]
            : current.caseTypeIds.filter((id) => id !== caseTypeId);
        writeSelection(selection.map((item) => (item.milestoneTypeId === node.milestoneTypeId ? { ...item, caseTypeIds } : item)));
    }
    function toggleFolder(key, checked) {
        setValue("_contractFoldersSelection", checked ? [...selectedFolders, key] : selectedFolders.filter((item) => item !== key));
    }
    /** Awaryjne wyjście: bez tego awaria endpointu zablokowałaby rejestrację umów. */
    function skipTree() {
        setValue("_contractStructureTreeUnavailable", true);
        setValue("_milestonesSelection", undefined, { shouldValidate: true });
        setValue("_contractFoldersSelection", undefined);
    }
    if (!contractTypeId)
        return (react_1.default.createElement("div", { className: "text-muted small mt-3", "data-testid": "structure-tree-no-type" }, "Najpierw wybierz typ umowy \u2014 pojawi si\u0119 lista kamieni milowych i spraw do utworzenia."));
    if (errorMessage)
        return (react_1.default.createElement(react_bootstrap_1.Alert, { variant: "warning", className: "mt-3", "data-testid": "structure-tree-error" },
            "Nie uda\u0142o si\u0119 wczyta\u0107 struktury umowy: ",
            errorMessage,
            react_1.default.createElement("div", { className: "mt-2 d-flex gap-2" },
                react_1.default.createElement(react_bootstrap_1.Button, { size: "sm", variant: "outline-secondary", onClick: () => setReloadToken((t) => t + 1) }, "Pon\u00F3w"),
                react_1.default.createElement(react_bootstrap_1.Button, { size: "sm", variant: "outline-secondary", onClick: skipTree }, "Utw\u00F3rz domy\u015Bln\u0105 struktur\u0119"))));
    if (!tree)
        return (react_1.default.createElement("div", { className: "mt-3 text-muted small d-flex align-items-center gap-1", "data-testid": "structure-tree-loading" },
            react_1.default.createElement(react_bootstrap_1.Spinner, { animation: "border", size: "sm" }),
            react_1.default.createElement("span", null, "Wczytuj\u0119 struktur\u0119 umowy\u2026")));
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_bootstrap_1.Form.Group, { className: "mt-3", controlId: "_milestonesSelection" },
            react_1.default.createElement(react_bootstrap_1.Form.Label, null, "Kamienie milowe i sprawy do utworzenia"),
            react_1.default.createElement("div", { className: "text-muted small mb-2", "data-testid": "structure-tree-folders-note" }, "Zaznaczenie kamienia zak\u0142ada na Dysku podfoldery wszystkich jego typ\u00F3w spraw, tak\u017Ce tych niezaznaczonych. Odznaczenie sprawy pomija sam\u0105 spraw\u0119 - folder i tak b\u0119dzie czeka\u0142 pusty."),
            react_1.default.createElement("div", { "data-testid": "structure-tree" }, tree.milestoneTypes.map((node) => {
                const current = selection.find((item) => item.milestoneTypeId === node.milestoneTypeId);
                const selectedCaseIds = current?.caseTypeIds ?? [];
                const isExpanded = expanded.has(node.milestoneTypeId);
                return (react_1.default.createElement("div", { key: node.milestoneTypeId },
                    react_1.default.createElement("div", { className: "d-flex align-items-start" },
                        react_1.default.createElement(react_bootstrap_1.Button, { variant: "link", size: "sm", className: "p-0 me-1 text-muted", style: {
                                width: "1.2rem",
                                visibility: node.caseTypes.length ? "visible" : "hidden",
                            }, onClick: () => toggleExpanded(node.milestoneTypeId), "aria-label": isExpanded ? "Zwiń" : "Rozwiń", "aria-expanded": isExpanded, type: "button" },
                            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: isExpanded ? free_solid_svg_icons_1.faChevronDown : free_solid_svg_icons_1.faChevronRight, size: "sm" })),
                        react_1.default.createElement(CheckRow, { id: `milestoneType-${node.milestoneTypeId}`, checked: !!current, muted: !node.hasTemplate, labelClassName: "fw-semibold", labelStyle: MILESTONE_LABEL_STYLE, onChange: (checked) => toggleMilestone(node, checked) },
                            react_1.default.createElement(TypeLabel, { folderNumber: node.folderNumber, typeName: node.typeName, isUnique: node.isUniquePerContract, templateName: node.templateName }))),
                    isExpanded && (react_1.default.createElement("div", { className: "ms-4 ps-3" }, node.caseTypes.map((caseType) => (react_1.default.createElement(CheckRow, { key: caseType.caseTypeId, id: `caseType-${caseType.caseTypeId}`, checked: selectedCaseIds.includes(caseType.caseTypeId), muted: !caseType.hasTemplate, onChange: (checked) => toggleCase(node, caseType.caseTypeId, checked) },
                        react_1.default.createElement(TypeLabel, { folderNumber: caseType.folderNumber, typeName: caseType.typeName, isUnique: caseType.isUniquePerMilestone, templateName: caseType.templateName }))))))));
            })),
            errors._milestonesSelection && (react_1.default.createElement("div", { className: "small text-danger mt-1", "data-testid": "structure-tree-error-message" }, errors._milestonesSelection.message))),
        react_1.default.createElement(react_bootstrap_1.Form.Group, { className: "mt-3" },
            react_1.default.createElement(react_bootstrap_1.Form.Label, null, "Dodatkowe foldery na Dysku"),
            react_1.default.createElement("div", { "data-testid": "optional-folders" }, tree.optionalFolders.map((folder) => (react_1.default.createElement("div", { key: folder.key },
                react_1.default.createElement(CheckRow, { icon: free_solid_svg_icons_1.faFolder, id: `folder-${folder.key}`, checked: selectedFolders.includes(folder.key), onChange: (checked) => toggleFolder(folder.key, checked) }, folder.name),
                FOLDER_HINTS[folder.key] && (react_1.default.createElement("div", { className: "text-muted small ms-4 ps-2" }, FOLDER_HINTS[folder.key])))))))));
}
